import { DatePicker, DateTimePicker, MultiViewCalendar, MultiViewCalendarProps } from '@progress/kendo-react-dateinputs'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { Field } from '@progress/kendo-react-form'
import { Input, TextArea } from '@progress/kendo-react-inputs'
import { MouseEvent as ReactMouseEvent, useEffect, useState } from 'react'

import {
  distritos,
  entidadeUser,
  estadoCandidatura,
  fillCombosAuxiliares,
  fillEstadoCandidaturaAsync,
  fillInstrumentoFinanciamentoAsync,
  fillTipoIncidenciaAsync,
  freguesias,
  get,
  getCandidaturaSelected,
  GetUserNameTecnico,
  instrumentoFinanciamento,
  instrumentoPlaneamento,
  nuts1,
  setCandidaturaSelected,
  tipoIncidencia,
  useCombos
} from '../../services/utils'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import { filterBy } from '@progress/kendo-data-query'
import { PESQUISAR_ENTIDADEBYUSER } from '../../utils/constants'
import CurrencyInput from 'react-currency-input-field'

type IProps = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined,
  formRenderProps?: any,
  viewMode?: boolean
  invPrevisto?: any
  setInvPrevisto?: any
  invComunitario?: any
  setInvComunitario?: any
  invNacional?: any
  setInvNacional?: any
}



export default function IdetificacaCandidatura({ onCloseClick, formRenderProps, viewMode, invPrevisto, setInvPrevisto , invComunitario, setInvComunitario, invNacional, setInvNacional }: IProps) {

  //  VALIDAÇÕES CURRENCY INPUT
  const [invPrevistoFocused, setInvPrevistoFocused] = useState(false);
  const [invComunitarioFocused, setInvComunitarioFocused] = useState(false);
  const [invNacionalFocused, setInvNacionalFocused] = useState(false);

 const getEntidadeByUser = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

useEffect(() => {

     if(!estadoCandidatura)
     {
      fillEstadoCandidaturaAsync();
     }
     if(!tipoIncidencia )
      {
      fillTipoIncidenciaAsync();
      }

      if (getCandidaturaSelected()?.id) {
        formRenderProps.onChange('inv_previsto_total', { value: invPrevisto});
        setInvPrevisto(getCandidaturaSelected()?.inv_previsto_total)
        formRenderProps.onChange('inv_comp_total', { value: getCandidaturaSelected().inv_comp_total });
        setInvComunitario(getCandidaturaSelected()?.inv_comp_total)
        formRenderProps.onChange('inv_nacional_total', { value: getCandidaturaSelected().inv_nacional_total });
        setInvNacional(getCandidaturaSelected().inv_nacional_total)
        formRenderProps.onChange('data_hora_registo', { value: getCandidaturaSelected().data_hora_registo ? new Date(getCandidaturaSelected().data_hora_registo) : new Date() });
        
        if(getCandidaturaSelected()?.utilizador) {
          formRenderProps.onChange('utilizador_registo', { value: getCandidaturaSelected()?.utilizador?.userName });
          getEntidadeByUser(getCandidaturaSelected()?.utilizador?.id).then(resultEntidade => {
            console.log(resultEntidade);
            formRenderProps.onChange('entidade_registo', { value: resultEntidade?.nome });
          });
        }
         
      }
      else {
        formRenderProps.onChange('entidade_registo', { value: entidadeUser });
            GetUserNameTecnico(undefined).then(tecnicoResult => {
                formRenderProps.onChange('utilizador_registo', { value:  tecnicoResult});
              })
      }
  }, []);

  useEffect(() => {
    if (getCandidaturaSelected()?.id) {
      formRenderProps?.onChange('id', { value: getCandidaturaSelected()?.id });
    }
  }, [getCandidaturaSelected()?.id])


  type combosKeys = 'estadoCandidatura'
  | 'tipoIncidencia' | 'instrumentoFinanciamento';

  const [combos, setCombos] = useState<any>({
    estadoCandidatura, 
    tipoIncidencia,
    instrumentoFinanciamento
  })
  
  const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
    estadoCandidatura: {
      setFn: setCombos,
      data: estadoCandidatura
    },
    tipoIncidencia: {
      setFn: setCombos,
      data: tipoIncidencia
    },
    instrumentoFinanciamento: {
      setFn: setCombos,
      data: instrumentoFinanciamento
    }
  };

  const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
    const { setFn, data } = setDataOption[tipoCombo];
      setFn({
          ...combos,
          [tipoCombo]: filterBy(data?.slice()??[], e.filter)
      }
      );
}

const changeFileDoc = (e: any) => {
  setCandidaturaSelected({...getCandidaturaSelected(), filedoc_cod: e?.value})
}

const CustomCalendar = (props: MultiViewCalendarProps) => {
  return <MultiViewCalendar {...props} views={1} />
}
const keyPressTextArea = (e: any) => {
  if (viewMode) {
    e.preventDefault();
    return false;
  }
}

  return (
    <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
      <fieldset style={{paddingBottom: '10px'}}>
        <legend>
          <span className={styles.fieldsetTitulo}>Registo</span>
        </legend>
        <div className={styles.espacoVerticalFieldSet}>
        <div className={styles.fields}>
            <div>
              <Field name="id" label="ID" component={Input} disabled />
            </div>
            <div>
              <Field name="filedoc_cod" onChange={changeFileDoc} label="Nº Processo APA" component={Input} maxLength={25} disabled={viewMode} />
            </div>
            <div>
            <Field
              name="estado_candidatura_id"
              label="Estado"
              component={ComboBox}
              textField={'descricao'}
              filterable={true}
              onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'estadoCandidatura')}}
              data={combos?.estadoCandidatura}
              disabled={viewMode}
  />
          </div>
          </div>
          </div>
          <div className={styles.fields}>
          <div>
              <Field
                name="data_hora_registo"
                label="Data/hora registo"
                format="dd/MM/yyyy HH:mm"
                component={DatePicker}
                disabled
                calendar={CustomCalendar}
              />
            </div>
            <div>
            <Field
                name="utilizador_registo"
                label="Técnico de registo"
                disabled
                component={Input}
              />
            </div>
            <div>
            <Field
              name="entidade_registo"
              label="Entidade"
              disabled
              component={Input}
            />
            </div>
          </div>
        </fieldset>
      <fieldset >
        <legend>
          <span className={styles.fieldsetTitulo}>Identificação</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
          
          <div className={styles.fields}>
          <div>
              <Field
                name="cod_candid"
                label="N.º de candidatura"
                component={Input}
                maxLength={50}
                disabled={viewMode}
              />
              </div>
              <div>
                <span className={`k-floating-label-container ${invPrevisto == null || invPrevisto == undefined ? "k-empty" : ""} ${invPrevistoFocused ? "k-focus" : ""}`}>
                  <CurrencyInput
                    customInput={Input}
                    id="inv_previsto_total"
                    name="inv_previsto_total"
                    //placeholder="Investimento Previsto"
                    decimalsLimit={2} 
                    decimalScale={2}
                    decimalSeparator=','       
                    groupSeparator=" "     
                    prefix=""                     
                    value={invPrevisto}
                    onValueChange={(valueLocal: any) => setInvPrevisto(valueLocal)}
                    disabled
                    className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                    onFocus={() => setInvPrevistoFocused(true)}
                    onBlur={() => setInvPrevistoFocused(false)}
                  />
                  <label htmlFor="inv_previsto_total" className="k-label">Investimento Previsto [€]</label>
                </span>
              {/* <Field
                name="inv_previsto_total"
                label="Investimento Previsto"
                component={Input}
                maxLength={25}
                disabled
              /> */}
              </div>
            </div>
          <div className={styles.fields}>
          <div>
              <Field
                name="data_registo"
                label="Data de aprovação"
                format="dd/MM/yyyy HH:mm"
                component={DateTimePicker}
                calendar={CustomCalendar}
                
              />
            </div>
            <div>
              <span className={`k-floating-label-container ${invComunitario == null || invComunitario == undefined ? "k-empty" : ""} ${invComunitarioFocused ? "k-focus" : ""}`}>
                <CurrencyInput
                  customInput={Input}
                  id="inv_comp_total"
                  name="inv_comp_total"
                  //placeholder="Investimento Comunitário"
                  decimalsLimit={2} 
                  decimalScale={2}
                  decimalSeparator=','       
                  groupSeparator=" "     
                  prefix=""                      
                  value={invComunitario}
                  onValueChange={(valueLocal: any) => setInvComunitario(valueLocal)}
                  disabled
                  className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                  onFocus={() => setInvComunitarioFocused(true)}
                  onBlur={() => setInvComunitarioFocused(false)}
                />
                <label htmlFor="inv_comp_total" className="k-label">Investimento Comunitário [€]</label>
              </span>
              {/* <Field
                name="inv_comp_total"
                label="Investimento Comunitario"
                component={Input}
                disabled
              /> */}
              </div>
          </div>
       <div className={styles.fields}>
       <div>
              <Field
                name="data_submissao"
                label="Data submissão"
                format="dd/MM/yyyy"
                component={DatePicker}
                disabled={viewMode}
                calendar={CustomCalendar}
                />
            </div>
            <div>
              <span className={`k-floating-label-container ${invNacional == null || invNacional == undefined ? "k-empty" : ""} ${invNacionalFocused ? "k-focus" : ""}`}>
                <CurrencyInput
                  customInput={Input}
                  id="inv_nacional_total"
                  name="inv_nacional_total"
                  placeholder="Investimento Nacional"
                  decimalsLimit={2} 
                  decimalScale={2}
                  decimalSeparator=','       
                  groupSeparator=" "     
                  prefix=""                        
                  value={invNacional}
                  onValueChange={(valueLocal: any) => setInvNacional(valueLocal)}
                  disabled
                  className='siarl-custom-input k-input-md k-rounded-md k-input-solid'
                  onFocus={() => setInvNacionalFocused(true)}
                  onBlur={() => setInvNacionalFocused(false)}
                />
                <label htmlFor="inv_nacional_total" className="k-label">Investimento nacional [€]</label>
                </span>
              {/* <Field
                name="inv_nacional_total"
                label="Investimento Nacional"
                component={Input}
                disabled
              /> */}
              </div>
       </div>
        <div className={styles.espacoVerticalFieldSet}>
              <Field name="designacao" label="Designação" component={Input} maxLength={255} disabled={viewMode}/>
           </div>
           </div>

      </fieldset>
      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>Tipologia</span>
        </legend>

        <div className={styles.espacoVerticalFieldSet}>
            <div>
              <Field
                name="id_tipo_in"
                label="Tipo de Incidência"
                component={ComboBox}
                textField={'descricao'}
                filterable={true}
                onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'tipoIncidencia')}}
                data={combos?.tipoIncidencia}            
                disabled={viewMode}
              />
            </div>
          </div>
      </fieldset>
      <fieldset>
        <legend>
          <span className={styles.fieldsetTitulo}>
            Instrumento de financiamento
          </span>
        </legend>
        <div className={styles.espacoVerticalFieldSet}>
          <div className={styles.fields}>
            <div>
              <Field
                name="instr_financiamento_id"
                label="Instrumento de financiamento"
                component={ComboBox}
                textField={'designacao'}
                filterable={true}
                onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'instrumentoFinanciamento')}}
                data={combos?.instrumentoFinanciamento}  
                disabled={viewMode}
              />
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
      <legend>
          <span className={styles.fieldsetTitulo}>
            Observações
          </span>
        </legend>
        <div>
          <Field
            name="obs"
            label="Observações"
            placeHolder='Observações gerais'
            component={TextArea}
            maxLength={528}
            style={{opacity: viewMode ? '0.7' : '1'}}
            onKeyDown={keyPressTextArea}
          />
        </div>
      </fieldset>
    </div>
  )
}
